// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"S8-z"};